export abstract class SuggestedAddressRules {
  abstract icon: string;
}
